<template>
  <div class="pa-park-banner" v-if="isLoadedPark" @click="handleClickBanner">
    <div class="left-side">
      <div class="park-number-title">
        <ParkNumberTitleImage />
      </div>
      
      <div class="park-number-set">
        <p>{{park.park_category.category_number | mutateFullWidth}}号帯</p>
        <p class="second">{{park.park_number.full | mutateFullWidth}}</p>
      </div>

      <PAParkAreaBanner
        :couldDisplayAreaInfomationModal="couldDisplayAreaInfomationModal"
        :areaName="park.park_level.position_name"
        :areaLevel="park.park_level.position_icon"
        :areaLevelNum="park.park_level.position_icon_count"

        @click="handleClickAreaBanner"
      />
    </div>
    
    <div class="right-side">
      <div class="right-side-item-wrap">
        <div class="pa-title">{{park.name | nameTruncate}}</div>
      </div>

      <div class="right-side-item-wrap">
        <div class="pa-caption" :class="additionalCaptionClass">{{park.caption | nameTruncate}}</div>
      </div>
      
      <div class="pa-description">
        <p>{{displayDescription}}</p>

        <template v-if="isVisibleCollapseButton">
          <p class="collapse-button-field">
            <span class="collapse-button" @click.prevent="handleClickCollapse">{{isDescriptionCollapse | collapseButtonText}}</span>
          </p>
        </template>
      </div>

      <div class="right-side-item-wrap" v-if="hasExpireAtField">
        <div class="pa-caption pa-caption-date">異世界地球時間{{expireAt | mutateJPFullWidthOnlyDate}}頃迄</div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import ParkNumberTitleImage from '@/components/Parts/PAParkBanner/Images/park-number-title.svg?inlineN'

import PAParkAreaBanner from '@/components/Parts/PAParkAreaBanner/PAParkAreaBanner.vue'

import {GetParkData} from '@/graphql/queries/Park.graphql'

export default {
  props : {
    parkId  : {
      default: null
    },

    expireAt : {
      default: null
    },

    link : {
      default: false
    },

    couldExpandDescription : {
      default: false
    },

    shoudExpandTextDefault : {
      default: false
    },

    couldDisplayAreaInfomationModal : {
      default: false
    }
  },

  components : {
    ParkNumberTitleImage,
    PAParkAreaBanner
  },

  filters : {
    collapseButtonText(value){
      if(value === true){
        return '説明を短くする';
      }else{
        return '説明をすべて表示する';
      }
    }
  },

  computed : {
    isLoadedPark(){
      if(typeof this.park === 'undefined' || this.park === null){
        return false;
      }else{
        return true;
      }
    }
  },

  data(){
    return {
      parkNumber              : '',
      parkNumberSecond        : '',
      parkAreaName            : '',
      parkAreaLevel           : 3,
      parkType                : 'system',
      additionalCaptionClass  : {
        'pa-caption-private'  : false
      },

      isVisibleCollapseButton     : false,
      isDescriptionCollapse       : false,
      displayDescription          : '',

      hasExpireAtField            : false,
    }
  },

  watch : {
    expireAt : {
      handler(value){
        if(value !== null){
          this.hasExpireAtField = true;
        }else{
          this.hasExpireAtField = false;
        }
      },
      immediate: true
    },

    shoudExpandTextDefault  : {
      handler(value){
        this.isDescriptionCollapse = value;
      }
    },
    
    couldExpandDescription  : {
      handler(value){
        this.isVisibleCollapseButton = value;
      },
      immediate: true
    },

    isDescriptionCollapse : {
      handler(){
        if(typeof this.park === 'undefined') return;

        this.displayDescription = this.mutateDisplayDescription(
          this.park.description
        );
      }
    },

    park : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(data === null) return;
        
        this.displayDescription = this.mutateDisplayDescription(
          data.description
        );

        if(data.description.length < 100){
          this.isVisibleCollapseButton = false;
        }

        this.parkType = data.park_type;
      },
      immediate: true,
      deep: true
    },

    parkType : {
      handler(value){
        if(value === 'user'){
          this.additionalCaptionClass['pa-caption-private'] = true;
        }else{
          this.additionalCaptionClass['pa-caption-private'] = false;
        }
      },
      immediate: true
    }
  },

  apollo : {
    park : {
      query : GetParkData,

      variables(){
        return {
          id : this.parkId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  methods : {
    handleClickBanner(){
      if(this.link === false) return;
      
      this.$router.push({
        name    : 'parks.detail',
        params  : {
          parkId: this.park.id
        },
      });
    },

    handleClickCollapse(){
      this.isDescriptionCollapse = !this.isDescriptionCollapse;
    },

    mutateDisplayDescription(text){
      if(this.isDescriptionCollapse === true){
        return text;
      }else{
        return this.$options.filters.jpSmaryTruncate(text);
      }
    },

    handleClickAreaBanner(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['is_open_park_area_infomation_modal'] = 'yes';
      newUrlQuery['y'] = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-park-banner{
  user-select: none;

  background-color: #CCAA8B;
  border-radius: 8px;
  width:100%;
  padding-bottom:.2rem;

  @include from($desktop) {
    padding:.5rem 0 .3rem;
  }

  .clearfix{
    clear: both;
  }

  .left-side{
    width:33%;
    float: left;

    .park-number-title{
      margin:.4rem .4rem 0;
      background-color: #89620C;
      border-radius: 4px;
      line-height: normal;
      padding:0 .2rem;

      @include from($desktop) {
        margin:8px 8px 0;
        padding:4px 0 0;
        text-align: center;
      }

      svg{
        .a{fill:#d2ba9e;}

        @include from($desktop) {
          max-width:130px;
          margin: 0 auto;
        }
      }
    }

    .park-number-set{
      background-color: #D2BA9E;
      border-radius: 4px;
      margin:.2rem .4rem;
      text-align: center;
      padding:.15rem .2rem .1rem;
      font-size:.73rem;

      p{
        margin:0;
        padding:0;
        line-height: 1.35;
        letter-spacing: .03rem;

        @include from($desktop) {
          margin:4px 8px;
          font-size:.9rem;
        }

        @include until(375px) {
          font-size:.7rem;
        }

        &.second{
          font-size:.9rem;
          letter-spacing: .05rem;

          @include from($desktop) {
            font-size:1rem;
          }

          @include until(375px) {
            font-size:.78rem;
          }
        }
      }
    }
  }

  .right-side{
    width:100%;

    .right-side-item-wrap{
      width:67%;
      box-sizing: border-box;
      display: block;
      margin: 0 0 0 auto;
    }

    .pa-title{
      color:#7F4F16;
      font-size:1.3rem;
      padding-top:.1rem;
      letter-spacing: .05rem;
      margin-right: .5rem;

      @include from($desktop) {
        font-size:1.5rem;
      }

      @include until(375px) {
        font-size:1rem;
      }
    }

    .pa-caption{
      color:#843D0D;
      background-color: #C49065;
      border-radius: 4px;
      font-size:.7rem;
      padding:.2rem;
      margin-right:.5rem;
      letter-spacing: .06px;

      &-private{
        color:#73370E;
        background-color: #C16292;
      }

      &-date{
        color: #7C5E49;
        background-color: #D2AF90;
      }

      @include from($desktop) {
        font-size:.85rem;
        padding:.2rem .5rem;
      }

      @include until(375px) {
        font-size:.7rem;
        padding:.1rem .2rem;
        margin-right:.3rem;
        letter-spacing: .03px;
      }
    }

    .pa-description{
      padding:.2rem .5rem .2rem .1rem;
      font-size:.8rem;
      letter-spacing: .06px;

      @include from($desktop) {
        padding:.4rem .5rem .2rem .2rem;
        font-size:.9rem;
      }

      @include until(375px) {
        font-size:.7rem;
        letter-spacing: .03px;
      }

      .collapse-button-field{
        text-align: right;

        .collapse-button{
          font-size: .6rem;
          color:#8A491D;
          border-bottom:1px solid #8A491D;
        }
      }
    }
  }
}
</style>